<template>
  <div class="lineup-widget">
    <div class="grid">
      <WidgetHeading
        class="title"
        :content="widget.title"
        is-big
        :is-first="isFirst"
      >
        <template #right>
          <Filters
            class="filters"
            :query-key="FILTER_KEY"
            :options="dateOptions"
          />
        </template>
      </WidgetHeading>
      <ClientOnly>
        <LineUpStageFiltered
          v-if="!isDesktop"
          :stages="selectedDateItems.stages"
          class="stage-filtered"
        />
        <template #fallback>
          <LineUpStageSlider
            :widget-id="widget.id"
            :stages="selectedDateItems.stages"
            class="lg-up"
          />
        </template>
      </ClientOnly>
    </div>
    <ClientOnly>
      <LineUpStageSlider
        v-if="isDesktop"
        :widget-id="widget.id"
        :stages="selectedDateItems.stages"
      />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import { PublicLineUpWidget } from '@/service/__generated-api'
import { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicLineUpWidget>>()

const { t } = useI18n()
const route = useRoute()

const isDesktop = useIsDesktop()
const FILTER_KEY = 'date'
const selectedDate = computed(() => route.query[FILTER_KEY])

const dateOptions = computed(() =>
  props.widget.items.map(({ date }, index) => {
    const formatted = formatDate(date, 'D.MM', false)
    return {
      label: `${formatted} ${t(`ordered-days.${index}`)}`,
      value: !index ? undefined : formatted,
      ariaLabel: formatDate(date, 'dddd D.MM', false)
    }
  })
)

const selectedDateItems = computed(
  () =>
    props.widget.items.find(
      ({ date }) => formatDate(date, 'D.MM', false) === selectedDate.value
    ) ?? props.widget.items[0]
)
</script>

<style lang="scss" scoped>
.lineup-widget {
  position: relative;
  // prevent next widget from covering mobile filters
  z-index: 1;
}

.title,
.stage-filtered,
.stage-slider {
  @include media-column(
    (
      xs: 4,
      md: 8,
      lg: 12
    )
  );
}

.filters {
  :deep(.active-filter) {
    @include media-down(lg) {
      width: rem(84px);
    }
  }

  :deep(.option-text) {
    @include media-down(lg) {
      max-width: rem(150px);
    }
  }

  :deep(.options) {
    top: rem(38px);
  }
}
</style>
